<div class="menu-items-tip">
  <ion-slides *ngIf="hasSlide else noSlides" (ionSlidesDidLoad)="updateSlides()" (ionSlideDidChange)="onSlideChange()" class="slide-tip-container">
    <ion-slide class="slide-tip" *ngFor="let slideItems of chunkItems; let firstSlides=first ">
      <div class="menu-items-tip__wrapper"
           [style.flex]="flexCss ? flexCss : null"
           *ngFor="let item of slideItems; let firstItem=first">
        <div
          class="menu-items-tip__item"
        >
          <button
            (click)="clickItem(item)"
            [ngClass]="{'selected-tip-item' : isChecked(item)}"
            type="button"
            class="menu-items__btn menu-items-tip__btn">
            <ng-container
              *ngIf="itemTemplateRef else defaultItem"
              [ngTemplateOutlet]="itemTemplateRef"
              [ngTemplateOutletContext]="{$implicit:item, first: firstSlides && firstItem, checked: isChecked(item)}"
            >
            </ng-container>
            <ng-template #defaultItem>
              {{item}}
            </ng-template>
          </button>
        </div>
      </div>
    </ion-slide>
  </ion-slides>
  <ng-template #noSlides>
    <div class="menu-items-tip__wrapper"
         *ngIf="startTemplateRef"
         [style.flex]="flexCss ? flexCss : null">
      <div
        class="menu-items-tip__item"
      >
        <button
          [ngClass]="{'selected-tip-item' : selectedStart}"
          class="menu-items__btn menu-items-tip__btn">
          <ng-container
            [ngTemplateOutlet]="startTemplateRef">
          </ng-container>
        </button>

      </div>
    </div>
    <div class="menu-items-tip__wrapper"
         [style.flex]="flexCss"
         *ngFor="let item of items; let first=first; let i = index">
      <div
        class="menu-items-tip__item"
      >
        <button
          (click)="clickItem(item)"
          [ngClass]="{'selected-tip-item' : isChecked(item)}"
          [id]="'time' + i"
          type="button"
          class="menu-items__btn menu-items-tip__btn">
          <ng-container
            *ngIf="itemTemplateRef else defaultItem"
            [ngTemplateOutlet]="itemTemplateRef"
            [ngTemplateOutletContext]="{$implicit:item, first: first, checked: isChecked(item)}"
          >
          </ng-container>
          <ng-template #defaultItem>
            {{item}}
          </ng-template>
        </button>
      </div>
    </div>
    <div class="menu-items-tip__wrapper"
         *ngIf="endTemplateRef"
         [style.flex]="targetFlexEndCss">
      <div
        class="menu-items-tip__item"
      >
        <button
          [ngClass]="{'selected-tip-item' : selectedEnd}"
          (click)="clickEnd()"
          (mouseenter)="hoverEnd=true"
          (mouseleave)="hoverEnd=false"
          class="menu-items__btn menu-items-tip__btn">
          <ng-container
            [ngTemplateOutlet]="endTemplateRef"
            [ngTemplateOutletContext]="{checked: selectedEnd, hover: hoverEnd}"
          >
          </ng-container>
        </button>

      </div>
    </div>
  </ng-template>
</div>
